import {connect} from "react-redux";
import DetalhamentoLiquidacoesFalhasSLC from "./liquidacoesFalhas";

export default connect()(DetalhamentoLiquidacoesFalhasSLC)